<template>
  <el-scrollbar>
    <div style="margin: 15px">
      <h4>社保公积金信息：</h4>
      <div class="box">
      <el-form :model="employeeData" label-width="190px">
        <el-row>
          <el-col :span="11">
            <el-form-item label="员工：" required>
              <el-select v-model="employeeData.employee_no" placeholder="员工" @change="getSecurityInfo" filterable clearable :disabled="isEdit">
                <el-option v-for="item in employeeList" :key="item.id" :label="item.employee_name" :value="item.employee_no"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="生效月份：" required>
              <el-date-picker v-model="employeeData.work_month" type="month"  :disabled="isEdit"
                              value-format="YYYY-MM" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="社保模板：" required>
              <el-input v-model="employeeData.sb_template_name" disabled/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="基本养老保险缴费比例：" required>
              <el-input v-model="employeeData.old_age_insurance_employee" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="是否缴纳：" required>
              <el-switch v-model="employeeData.old"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="失业保险缴费比例：" required>
              <el-input v-model="employeeData.unemployment_insurance_employee" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="是否缴纳：" required>
              <el-switch v-model="employeeData.unemployment"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="基本医疗保险缴费比例：" required>
              <el-input v-model="employeeData.medical_insurance_employee" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="是否缴纳：" required>
              <el-switch v-model="employeeData.hospital"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="大额医疗费用补助：" required>
              <el-input v-model="employeeData.large_medical_employee" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="是否缴纳：" required>
              <el-switch v-model="employeeData.large_medical"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="公积金模板：" required>
              <el-input v-model="employeeData.gjj_template_name" disabled/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="公积金缴费比例：" required>
              <el-input v-model="employeeData.employee_pay_scale" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="是否缴纳：" required>
              <el-switch v-model="employeeData.gjj"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="备注：">
              <el-input type="textarea" v-model="employeeData.remark" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </div>
      <h4>附件：</h4>
      <div class="box">
      <el-form :model="employeeData" label-width="190px">
        <el-row>
          <el-col :span="11" >
            <el-form-item label="附件：">
              <kf-file-upload v-model="employeeData.attach_id" :init-file="fileList"
                              @fileChange="fileChange"
                              :limit="10" :showTotalCnt="true" ></kf-file-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11" >
            <el-form-item label="附件照片：">
              <el-button type="primary" style="width: 100px;" plain @click="openCameraMain">附件拍照</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11" >
            <el-form-item label="">
              <FrameItem v-model="employeeData.attach_photo_id" :file-list="attach_photo_id_obj" :item="uploadImgObj" ></FrameItem>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </div>
      <el-row>
        <el-col :span="24" style="text-align: center">
          <el-button type="primary" :loading="loading" @click="save" >保存</el-button>
        </el-col>
      </el-row>
    </div>
  </el-scrollbar>
  <el-dialog v-model="dialogVisible" style="width: 800px;height: 550px;">
    <img id="view1" src="http://127.0.0.1:38088/video=stream&camidx=0" alt="主摄像头" style="width: 770px;height:450px;">
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeCameraMain">取消</el-button>
        <el-button type="primary" @click="takePhotoTwo">
          拍照
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {Plus} from "@element-plus/icons-vue";
import axios from 'axios'

export default {
  name: "EmployeeSecurity",
  components: {Plus},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    boolList() {
      return this.$store.getters['core/getDictList']('bool');
    }
  },
  data() {
    return {
      optionProps: {
        emitPath: true,
        label: "name",
        value: "id",
        checkStrictly: true
      },
      uploadImgObj: {
        component: 'image_upload',
        limit: 1,
      },
      employee_no: '',
      employeeData: {
        employee_no: '',
        employee_name: '',
        department_ids: [],
        position_ids: '',
        position_level: '',
        phone: '',
        email: '',
        photo: '',
        entry_date: '',
        is_probation: false,
        probation_end_date: '',
        labor_company_id:'',
        employee_type:''
      },
      isEdit:false,
      isShow:false,
      photoType:'',
      dialogVisible: false,
      departmentList: [],
      reasonList: [],
      employeeList:[],
      loading: false,
      fileList:[],
      attach_photo_id_obj:[]
    }
  },
  methods: {
    async loadEmployeeSecurityRecord() {
      let params = {id: this.parentData.id}
      this.$http('salarySecurityFeeRecordService.getSecurityRecordById', params).then(data => {
        if (data) {
          this.isEdit = true;
          this.attach_photo_id_obj = data.attach_photo_id_obj;
          this.fileList = data.file_list;
          this.employeeData = data;
          this.getSecurityInfo();
        }
      }, errMsg => {
        //this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
      });
    },
    //获取员工
    async getEmployee(){
      this.employeeList =await this.$http('employeeInfoService.getAllEmployeeNoListByDept');
    },
    getSecurityInfo(){
      let params = {
        "employee_no": this.employeeData.employee_no,
        "id": this.parentData.id
      }
      this.$http('salarySecurityFeeRecordService.getSalarySecurityFeeTemplate', params).then(data => {
        if (data) {
          this.employeeData.employee_name = data.employee_name;
          this.employeeData.employee_no = data.employee_no;
          this.employeeData.user_id = data.user_id;
          this.employeeData.department_ids = data.department_ids;
          this.employeeData.sb_template_id = data.sb_template_id;
          this.employeeData.sb_template_name = data.sb_template_name;
          this.employeeData.old_age_insurance_employee = data.old_age_insurance_employee;
          this.employeeData.medical_insurance_employee = data.medical_insurance_employee;
          this.employeeData.large_medical_employee = data.large_medical_employee;
          this.employeeData.unemployment_insurance_employee = data.unemployment_insurance_employee;
          this.employeeData.gjj_template_id = data.gjj_template_id;
          this.employeeData.gjj_template_name = data.gjj_template_name;
          this.employeeData.employee_pay_scale = data.employee_pay_scale;
          if(!this.parentData.id){
            this.employeeData.old = data.old;
            this.employeeData.unemployment = data.unemployment;
            this.employeeData.hospital = data.hospital;
            this.employeeData.large_medical = data.large_medical;
            this.employeeData.gjj = data.gjj;
          }
        }
      }, errMsg => {
        //this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
      });
    },
    async openCameraMain(){
      this.dialogVisible = true;
      const image = document.getElementById('view1');
      image.src = 'http://127.0.0.1:38088/video=stream&camidx=0?1';
    },
    closeCameraMain(){
      let data = {"camidx": "0"}
      axios.post("http://127.0.0.1:38088/video=close", JSON.stringify(data)).then(()=>{
        document.getElementById('view1').src = ''
      });
      this.dialogVisible = false;
    },
    takePhotoTwo(){
      let params = {
        "filepath": "base64",
        "camidx": "0",
        "ColorMode": "0",
        "quality": "1"
      }
      axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(params)).then(response=>{
        if(response){
          let photoData = {photo: response.data};
          this.$http('photoService.takePhotoByMainCamera',photoData, false).then(data => {
            if(data){
              this.employeeData.attach_photo_id = data.avatar;
              this.attach_photo_id_obj = [data.file];
              this.dialogVisible = false;
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      });
    },
    save() {
      if (!this.employeeData) {
        this.$message.error("请选择员工");
        return;
      }
      if (!this.employeeData.employee_no) {
        this.$message.error("请选择员工");
        return;
      }
      if (!this.employeeData.work_month) {
        this.$message.error("请选择生效月份");
        return;
      }
      this.loading = true;
      this.$http('salarySecurityFeeRecordService.insertRecord', this.employeeData, false).then(() => {
        this.$message.success("保存成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.loading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        // console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.loading = false;
      })
    },
    //拍照
    async openCamera() {
      this.dialogVisible = true;
      //设置分辨率
      const data = {
        "mode": "0",
        "camidx": "1",
        "width": "1280",
        "height": "720"
      }
      try{
        const image = document.getElementById('view2');
        axios.post("http://127.0.0.1:38088/device=setresolution", JSON.stringify(data)).then(response=>{
          console.log(response.data);
          if(response.data.code === "0"){
            image.src = '';
          }
          image.src = 'http://127.0.0.1:38088/video=stream&camidx=1?1';
        });
      }catch(error){
        this.$message.error("摄像头打开失败"+error.message);
      }
    },
    async fileChange(ids) {
      if (ids.length <= 0) {
        return
      }
      this.employeeData.attach_id = ids;
    },
  },
  created() {
    this.getEmployee();
    this.loadEmployeeSecurityRecord();
  },
}
</script>

<style scoped lang="less">
.box {
  padding-top: 10px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  margin: 10px 0;
}

</style>